import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const modeloTareaImporterSelectors = importerSelectors(
  'modeloTarea.importer',
);

export default modeloTareaImporterSelectors;
